// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"32":"2c90259a","2157":"430e5549","3473":"44486b06","6028":"8b6afde3","6271":"430e5549","8688":"b3249b30"}[chunkId] + ".chunk.css";
};